import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { Addition } from '../interface';
import IconCheckmark from '../../../brenger-shared-ui/components/basics/icons/IconCheckmark';
import { SimplePrice } from '../../../brenger-shared-ui/components/other/pricedisplay/SimplePrice';

interface Props {
  additions: Addition[];
  renderCheckMark: boolean;
  isBlocked: boolean;
}

const AdditionList = ({ additions, renderCheckMark, isBlocked }: Props): JSX.Element => {
  return (
    <>
      {additions.map((item, index) => {
        return (
          <div className={'summary-line'} key={index}>
            <div>
              {renderCheckMark && <IconCheckmark />} {item.beforeText && item.beforeText}{' '}
              {item.transKey && <Translate id={item.transKey} />}
              {item.text && item.text} {item.afterText && item.afterText}
            </div>
            {item.price !== null && !isBlocked && (
              <div className={'adds-price'}>
                <SimplePrice price={item.price} addPlusMinusIndicator={true} />
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default AdditionList;
